export default __webpack_public_path__ + "images/loggedout/icons/cross-b8a13f3bbc21047f51ae6c676d7e33a1.png";